import { useCallback } from 'react';
import type { IssueTransitionModalPayload } from '../../common/types.tsx';
import { EVENT_OPEN_ISSUE_TRANSITION_MODAL } from './constants.tsx';
import { ITSPubSub } from './index.tsx';

export const usePublishOpenIssueTransitionModalPubSub = () =>
	useCallback((payload?: IssueTransitionModalPayload, isEnabled?: boolean) => {
		ITSPubSub.publish(EVENT_OPEN_ISSUE_TRANSITION_MODAL, { payload, isEnabled });
	}, []);
